import type { CreateItemAnchor } from '@atlassian/jira-software-roadmap-timeline-table/src/common/types/create.tsx';
import { createStore, createHook, type StoreState } from '@atlassian/react-sweet-state';

type State = {
	createItemAnchor: CreateItemAnchor;
};

const actions = {
	setCreateItemAnchor:
		(createItemAnchor: CreateItemAnchor) =>
		({ setState, getState }: StoreState<State>) =>
			setState({ ...getState(), createItemAnchor }),
} as const;
type Actions = typeof actions;

// @ts-expect-error - TS2344 - Type '{ readonly setCreateItemAnchor: (createItemAnchor: CreateItemAnchor) => ({ setState, getState }: StoreState<State>) => void; }' does not satisfy the constraint 'Record<string, ActionThunk<State, { readonly setCreateItemAnchor: (createItemAnchor: CreateItemAnchor) => ({ setState, getState }: StoreState<State>) => void; }>>'.
const Store = createStore<State, Actions>({
	initialState: { createItemAnchor: undefined },
	actions,
	name: 'JWMTimelineViewCreateItemAnchorStore',
});

// @ts-expect-error - TS2345 - Argument of type 'Store<State, { readonly setCreateItemAnchor: (createItemAnchor: CreateItemAnchor) => ({ setState, getState }: StoreState<State>) => void; }>' is not assignable to parameter of type 'Store<State, Record<string, ActionThunk<State, { readonly setCreateItemAnchor: (createItemAnchor: CreateItemAnchor) => ({ setState, getState }: StoreState<State>) => void; }>>>'.
export const useCreateItemAnchor = createHook(Store);
